import React from "react";
import { Link as RouterLink } from "react-router-dom";
// Fluent UI
import { Stack, Text, Link, Icon, DefaultPalette } from "@fluentui/react";

export default ({ text, link }) => (
  <Stack horizontalAlign="end">
    <Link as={RouterLink} to={link} className="unstyled-link">
      <Text
        variant="medium"
        styles={{ root: { color: DefaultPalette.themePrimary } }}
      >
        {text}{" "}
        <Text variant="smallPlus">
          <Icon iconName="Forward" />
        </Text>
      </Text>
    </Link>
  </Stack>
);
